import { ReactNode, useReducer } from 'react';

import { useTranslation } from '#/features/localization/utils';

import ButtonLink from './ButtonLink';

interface Preview {
  readonly children: ReactNode;
  readonly preview: string;
}

interface Ellipsize {
  readonly children: string;
  readonly maxLength: number;
}

type Props = Preview | Ellipsize;

const DEFAULT_SHOW_MORE_LABEL = 'read more';

export function ShowMoreText(props: Props) {
  const [isExpanded, toggle] = useReducer(
    (expanded: boolean) => !expanded,
    false,
  );
  const { t } = useTranslation();

  if (isExpanded) {
    return props.children;
  }

  if (isEllipsize(props)) {
    return (
      <>
        {/* Wrapping in a tag prevents the app from crashing due to issue with Google 
        Translate auto translating to Chinese when user tries to connect the wallet.
        Issue: https://bugs.chromium.org/p/chromium/issues/detail?id=872770 */}
        <span>{ellipsize(props.children, props.maxLength)}</span>
        <ButtonLink onClick={toggle}>{t(DEFAULT_SHOW_MORE_LABEL)}</ButtonLink>
      </>
    );
  }

  if (isPreview(props)) {
    return (
      <>
        {/* Wrapping in a tag prevents the app from crashing due to issue with Google 
        Translate auto translating to Chinese when user tries to connect the wallet.
        Issue: https://bugs.chromium.org/p/chromium/issues/detail?id=872770 */}
        <span>{props.preview}...</span>
        <ButtonLink onClick={toggle}>{t(DEFAULT_SHOW_MORE_LABEL)}</ButtonLink>
      </>
    );
  }

  return null;
}

function ellipsize(text: string, maxLength: number) {
  return `${text.slice(0, maxLength)}…`;
}

function isPreview(props: Props): props is Preview {
  return 'preview' in props;
}

function isEllipsize(props: Props): props is Ellipsize {
  return 'maxLength' in props;
}
